declare var ImagesParams: {
    UseCDNImageCache: boolean,
    CloudflareAccountHash: string
};

export default class Utils {
    static deleteCookie = (name: string) => {
        document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    };

    static getCookie(cookieName: string) {
        let cookie: any = {};
        document.cookie.split(';').forEach(function (el) {
            let [key, value] = el.split('=');
            cookie[key.trim()] = value;
        })

        return cookie[cookieName];
    }

    static setCookie(name: string, value: any, days: number) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        else {
            expires = "; expires=Session";
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    static setSessionCookie(name: string, value: any) {
        var expires = "";
        expires = "; expires=Session";
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }


    static getHashKeyValuePairs() {
        return this.getUrlKeyValuePairs(window.location.hash);
    }

    static getHrefKeyValuePairs() {
        return this.getUrlKeyValuePairs(window.location.search);
    }

    static getUrlKeyValuePairs(url: string) {
        var result = [];

        if (url) {
            var hash = url.substring(1); //removes the # or ? character for hash or queryString repectively.
            var pairs = hash.split('&');
            for (var i = 0; i < pairs.length; i++) {
                var pairParts = pairs[i].split('=');
                if (pairParts.length == 2) {
                    var key = pairParts[0];
                    var value = pairParts[1];
                    result.push({ key: key, value: value });
                }
            }
        }

        return result;
    }

    static loadImagesForProductListings_BasedOnView(prodListing: any) {
        var isGridView = prodListing.hasClass('view-as-grid');
        prodListing.find('.productImageWrapper img').each(function (index: any) {
            var img = document.querySelector(index);
            setTimeout(function () {
                var newImgUrl = img.closest('.innerwrapper').data(isGridView ? 'prodimggridview' : 'prodimglistview');
                // Set the new Img Url to the proper attribute src or lazy-src.
                if (img.attr("lazy-src")) {
                    img.attr("lazy-src", newImgUrl);
                }
                else if (img[0].src) {
                    img[0].src = newImgUrl;
                }
            }, 1);
        });
    }

    static getImageURL(width: number, height: number, imgUrl: string): string {
        if (ImagesParams.UseCDNImageCache) {
            if (imgUrl.startsWith('~')) {
                imgUrl = imgUrl.substring(1);
            }
            return `https://www.gak.co.uk/cdn-cgi/image/fit=scale-down,width=${width},height=${height},format=auto/${imgUrl}`;
        }
        else {
            return `https://www.gak.co.uk/cdn-cgi/imagedelivery/${ImagesParams.CloudflareAccountHash}/${imgUrl}/${width}x${height}`;
        }
        
    }

    static atou(b64: string) {
        return decodeURIComponent(escape(atob(b64)));
    }

    static utoa(data: any) {
        return btoa(unescape(encodeURIComponent(data)));
    }
}